// Pantalla de login: botón oficial de Google (GIS). El token se guarda y la app recarga.
import { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { renderGoogleButton, isNativeApp, loginNative } from '@/googleAuth'
import { Button } from '@/components/ui/Button'
import { InstallAppButton } from '@/components/InstallAppButton'
import { AppVersion } from '@/components/AppVersion'

export default function Login() {
  const { isAuthenticated } = useAuth()
  const btnRef = useRef<HTMLDivElement>(null)
  const native = isNativeApp()
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    // El botón oficial de Google solo aplica en web: dentro de la app nativa
    // Google rechaza su propio OAuth en WebView, así que ahí va el plugin.
    if (!native && btnRef.current) renderGoogleButton(btnRef.current).catch(() => {})
  }, [native])

  const entrarNativo = async () => {
    setBusy(true)
    setError(null)
    try {
      if (await loginNative()) window.location.assign('/')
      else setError('No se pudo obtener la sesión de Google.')
    } catch (e) {
      setError((e as { message?: string })?.message ?? 'No se pudo iniciar sesión.')
    } finally {
      setBusy(false)
    }
  }

  if (isAuthenticated) return <Navigate to="/" replace />

  return (
    <div className="flex min-h-full items-center justify-center bg-gradient-to-b from-slate-100 to-white p-6">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-lg ring-1 ring-black/5">
        <img src="/logo-hd.png" alt="Hotel Depot" className="mx-auto mb-5 h-16 w-auto" />
        <h1 className="text-xl font-bold text-hd-dark">Reparto de entregas</h1>
        <p className="mt-1 text-sm text-gray-500">Operación de almacén y ruta</p>

        {/* Web: botón oficial de Google. App nativa: selector de cuentas del sistema. */}
        {native ? (
          <Button onClick={entrarNativo} disabled={busy} className="mt-8 w-full py-3 text-base">
            {busy ? 'Entrando…' : 'Iniciar sesión con Google'}
          </Button>
        ) : (
          <div ref={btnRef} className="mt-8 flex justify-center" />
        )}
        {error && <p className="mt-3 text-sm text-red-700">{error}</p>}

        <InstallAppButton />

        <p className="mt-6 text-xs leading-relaxed text-gray-400">
          Acceso solo con tu cuenta de Google de Hotel Depot.
        </p>
        <AppVersion className="mt-1" />
      </div>
    </div>
  )
}
